module.exports = __webpack_public_path__ + "resources/img/bg-career-top@2x.8be08521.jpg";